import React from 'react';
import { Search } from './frame/search';

export const Component: React.FC<{
  search: string;
  setSearch: Function;
}> = ({ search, setSearch }) => {
  return <Search search={search} setSearch={setSearch} />;
};
